import { __decorate } from "tslib";
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, concat, defer, ignoreElements, map, of } from 'rxjs';
import _ from 'lodash';
import { SailsSocketService } from '../../modules/sails-socket';
import { ResourceService } from './resource.service';
let ResourceListService = class ResourceListService {
    sails = inject(SailsSocketService);
    resourceService = inject(ResourceService);
    resourceLists = new Map();
    _model = { array: [], byId: {}, byOrg: {} };
    get model() {
        return this._model;
    }
    getResourceLists() {
        return this.createObservable('/resourceList').pipe(map(({ data }) => {
            data.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
            this.updateModel(data);
            return this.model;
        }));
    }
    getResourceListForOrg(org) {
        const byOrg$ = defer(() => of(this._model.byOrg[org] || []));
        const retrieveSites$ = this.resourceLists.size ? EMPTY : this.getResourceLists();
        return concat(retrieveSites$.pipe(ignoreElements()), byOrg$);
    }
    getResourcesForResourceList(resourceListId) {
        return this.resourceService.getResourcesForResourceList(resourceListId);
    }
    updateModel(data) {
        this.resourceLists.clear();
        this._model.array = [];
        this._model.byId = {};
        this._model.byOrg = {};
        _.forEach(data, (list) => {
            this.resourceLists.set(list.id, list);
            this._model.array.push(list);
            this._model.byId[list.id] = list;
            this._model.byOrg[list.org] = this._model.byOrg[list.org] || [];
            this._model.byOrg[list.org].push(list);
        });
    }
    createObservable(url, method = 'get', data) {
        return new Observable((subscriber) => {
            const subscription = this.sails[method](url, data).subscribe({
                next: (response) => {
                    subscriber.next(response);
                    subscriber.complete();
                },
                error: (error) => subscriber.error(error),
            });
            return () => subscription.unsubscribe();
        });
    }
};
ResourceListService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ResourceListService);
export { ResourceListService };
